<script setup lang="ts">
import { computed } from 'vue';

import type { IncentiveStatus } from '../types';

import { STATUS_LABELS, STATUS_STYLES } from '../utils';

const props = withDefaults(defineProps<{
  label?: string;
  size?: 'md' | 'sm';
  status: IncentiveStatus;
}>(), {
  label: undefined,
  size: 'sm',
});

const displayLabel = computed(() => props.label ?? STATUS_LABELS[props.status]);
const style = computed(() => STATUS_STYLES[props.status]);
</script>

<template>
  <span
    class="status-badge"
    :class="{ 'status-badge--md': size === 'md' }"
    :style="{
      background: style.bg,
      color: style.color,
    }"
  >
    <span
      class="status-badge-dot"
      :style="{ background: style.dot }"
    />
    {{ displayLabel }}
  </span>
</template>

<style scoped lang="scss">
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 9px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.3;
  white-space: nowrap;
}

.status-badge--md {
  gap: 6px;
  padding: 6px 12px;
  font-size: 12px;
}

.status-badge-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}
</style>
